import React from 'react';
import { GlobeIcon } from 'lucide-react';
import { MatrixBackground } from './MatrixBackground';
interface LanguageSelectorProps {
  onSelectLanguage: (language: 'en' | 'es') => void;
}
export function LanguageSelector({
  onSelectLanguage
}: LanguageSelectorProps) {
  return <div className="fixed inset-0 bg-black/90 backdrop-blur-sm flex items-center justify-center z-[100] p-4" data-id="element-126">
      <MatrixBackground data-id="element-127" />
      <div className="bg-gradient-to-br from-teal-950 to-black border-2 border-teal-600/50 rounded-2xl p-8 md:p-12 max-w-md w-full shadow-2xl relative z-10" data-id="element-128">
        <div className="flex items-center justify-center gap-3 mb-6" data-id="element-129">
          <GlobeIcon className="w-10 h-10 text-yellow-400" data-id="element-130" />
          <h2 className="text-2xl md:text-3xl font-bold text-white" data-id="element-131">
            Select Your Language
          </h2>
        </div>
        <p className="text-center text-gray-300 mb-8" data-id="element-132">
          Choose your preferred language to continue
        </p>
        <div className="space-y-4" data-id="element-133">
          <button onClick={() => onSelectLanguage('en')} className="w-full bg-gradient-to-r from-yellow-600 to-yellow-700 text-black px-8 py-5 rounded-full text-xl font-bold hover:from-yellow-500 hover:to-yellow-600 transform hover:scale-105 transition-all" data-id="element-134">
            English
          </button>
          <button onClick={() => onSelectLanguage('es')} className="w-full bg-gradient-to-r from-teal-600 to-teal-700 text-white px-8 py-5 rounded-full text-xl font-bold hover:from-teal-500 hover:to-teal-600 transform hover:scale-105 transition-all" data-id="element-135">
            Español
          </button>
        </div>
      </div>
    </div>;
}